import React, { createContext, useState, useEffect } from "react";
import { getconfiguracion, loadUserConfig, loadUserConfig2 } from "../constants/config";

const UserConfigContext = createContext();

const toBool = (value) =>
  value === 1 || value === "1" || value === true || value === "true" || value === "on";

const normalizeEcommerceConfig = (config) => ({
  ...config,
  login: toBool(config?.login),
  carousel_home: toBool(config?.carousel_home),
  carousel_mueve: toBool(config?.carousel_mueve),
  con_sin_precio: toBool(config?.con_sin_precio),
  con_sin_stock: toBool(config?.con_sin_stock),
  mostrar_grupos: toBool(config?.mostrar_grupos),
  mostrar_marcas: toBool(config?.mostrar_marcas),
  mostrar_tipos: toBool(config?.mostrar_tipos),
  muestra_cuadrante: toBool(config?.muestra_cuadrante),
  registrarse: toBool(config?.registrarse),
});

const UserConfigProvider = ({ children }) => {
  const [config1, setConfig1] = useState(null);
  const [config2, setConfig2] = useState(null);
  const [configEcommerce, setConfigEcommerce] = useState(null);
  const [loadingConfig, setLoadingConfig] = useState(true);

  useEffect(() => {
    const fetchUserConfig = async () => {
      try {
        const [configData2, configData1, ecommerceConfigResponse] = await Promise.allSettled([
          loadUserConfig2(),
          loadUserConfig(),
          getconfiguracion(),
        ]);

        if (configData2.status === "fulfilled") {
          setConfig2(configData2.value);
        } else {
          console.error("Error al cargar configuracion de vista:", configData2.reason);
        }

        if (configData1.status === "fulfilled") {
          setConfig1(configData1.value);
        } else {
          console.error("Error al cargar datos iniciales:", configData1.reason);
        }

        if (ecommerceConfigResponse.status === "fulfilled") {
          setConfigEcommerce(normalizeEcommerceConfig(ecommerceConfigResponse.value?.data || {}));
        } else {
          console.error("Error al cargar configuracion ecommerce:", ecommerceConfigResponse.reason);
        }
      } catch (error) {
        console.error("Error al cargar la configuracion:", error);
      } finally {
        setLoadingConfig(false);
      }
    };

    fetchUserConfig();
  }, []);

  return (
    <UserConfigContext.Provider value={{ config1, config2, configEcommerce, loadingConfig }}>
      {children}
    </UserConfigContext.Provider>
  );
};

export { UserConfigProvider, UserConfigContext };
